/**
 * 環境判断ストア
 * Comspostion API で記述すること
 */
"use strict";

import { defineStore } from "pinia";
import { ref } from "vue";

export const useEnvStore = defineStore("envStore", () => {
  const isDev = ref(false);
  const isStg = ref(false);
  const isPrd = ref(false);

  //注意:axios.ts にも同様の分岐があるが、axios.tsとの共通化はできないので変更時は両方メンテナンスすること
  if (location.hostname === "127.0.0.1" || location.hostname === "localhost") {
    if (location.port === "8081") {
      isDev.value = true;
    } else {
      isStg.value = true;
    }
  } else {
    isPrd.value = true;
  }

  return {
    isDev,
    isStg,
    isPrd,
  };
});
